import React, { FunctionComponent, Fragment, useEffect, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { fetchWalletBalance } from '../Listing/actions';
import { parsePrice } from '../../../utils/utils';

const Wallet: FunctionComponent<{}> = () => {
  const dispatch = useDispatch();
  const balance = useSelector((state: any) => state.fasTag.balance);

  const dispatchToStore = useCallback(() => dispatch(fetchWalletBalance()), [dispatch]);

  useEffect(() => {
    dispatchToStore();
  }, [balance, dispatchToStore]);

  return (
    <Fragment>
      <span className="small" style={{ fontSize: '0.995rem', lineHeight: '28px' }}>
        Wallet Balance
      </span>
      <span className="ml5 large fwb">{parsePrice({ price: balance || 0 })}</span>
    </Fragment>
  );
};

export default Wallet;
